import _defineProperty from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { DealerErrors } from './typedefs';
import { PluginEvent } from '../../enums/plugin_event';
import { DealerError } from './error';
import { DealerEvent } from './event';
import { Dealer } from './dealer';
/**
 * The name of the Dealer Plugin.
 *
 * This value should be used when calling Transport methods like `hasPlugin()`
 * or `getPluginAPI()`.
 */

export var DEALER_PLUGIN_NAME = 'dealer';
/**
 * A Transport Plugin that implements the Dealer protocol.
 */

var DealerPlugin =
/*#__PURE__*/
function () {
  function DealerPlugin(options) {
    var _this = this;

    _classCallCheck(this, DealerPlugin);

    /**
     * The name of the plugin.
     */
    this.name = DEALER_PLUGIN_NAME;
    this._dealer = new Dealer(options); // Create the API, which is always bound to the instance.

    this.api = {
      hasConnectionInfo: function hasConnectionInfo() {
        return _this._dealer.hasConnectionId();
      },
      getConnectionInfo: function getConnectionInfo() {
        return _this._dealer.getConnectionInfo().then(function (info) {
          return Object.assign({
            plugin: _this.name
          }, info);
        });
      }
    }; // Rebind

    this._onDealerConnectionId = this._onDealerConnectionId.bind(this);
    this._onDealerDisconnected = this._onDealerDisconnected.bind(this);
    this._onDealerMessage = this._onDealerMessage.bind(this);
    this._onDealerRequest = this._onDealerRequest.bind(this);
    this._onTransportConnect = this._onTransportConnect.bind(this);
    this._onTransportAuthenticate = this._onTransportAuthenticate.bind(this);
    this._onTransportDisconnect = this._onTransportDisconnect.bind(this);
  }
  /**
   * Called when the Dealer instance receives a connection id.
   *
   * @param ev - The event object
   */


  _createClass(DealerPlugin, [{
    key: "_onDealerConnectionId",
    value: function _onDealerConnectionId(ev) {
      if (!this._mediator) {
        return;
      }

      this._mediator.emit(PluginEvent.PLUGIN_CONNECTION_INFO, Object.assign({
        plugin: this.name
      }, ev.data));
    }
    /**
     * Called when the dealer instance gets disconnected.
     *
     * @param ev - The event object
     */

  }, {
    key: "_onDealerDisconnected",
    value: function _onDealerDisconnected(ev) {
      if (!this._mediator) {
        return;
      }

      var data = ev.data;

      this._mediator.emit(PluginEvent.PLUGIN_DISCONNECTED, {
        plugin: this.name,
        code: data.wsCode,
        reason: data.reason
      });
    }
    /**
     * Called when the dealer instance receives a message.
     *
     * @param ev - The event object
     */

  }, {
    key: "_onDealerMessage",
    value: function _onDealerMessage(ev) {
      if (!this._mediator) {
        return;
      }

      this._mediator.emit(PluginEvent.PLUGIN_MESSAGE, Object.assign({
        plugin: this.name
      }, ev.data));
    }
    /**
     * Called when the dealer instance receives a request.
     *
     * @param ev - The event object
     */

  }, {
    key: "_onDealerRequest",
    value: function _onDealerRequest(ev) {
      if (!this._mediator) {
        return;
      }

      this._mediator.emit(PluginEvent.PLUGIN_REQUEST, Object.assign({
        plugin: this.name
      }, ev.data));
    }
    /**
     * Called when the transport instance starts connecting.
     *
     * @param ev - The event.
     */

  }, {
    key: "_onTransportConnect",
    value: function _onTransportConnect(ev) {
      var endpoints = ev.data.endpoints;
      var awaitPromise = ev.data.awaitPromise;

      if (!endpoints.dealer) {
        awaitPromise(Promise.reject(new DealerError(DealerErrors.ENDPOINT_NOT_DEFINED, 'No "dealer" endpoint defined.')));
        return;
      }

      if (!/^wss:/.test(endpoints.dealer)) {
        awaitPromise(Promise.reject(new DealerError(DealerErrors.INVALID_ENDPOINT, 'Dealer endpoint needs to be wss://')));
        return;
      }

      awaitPromise(this._dealer.connect(endpoints.dealer));
    }
    /**
     * Called when the Transport instance starts authenticating.
     *
     * @param ev - The event.
     */

  }, {
    key: "_onTransportAuthenticate",
    value: function _onTransportAuthenticate(ev) {
      var data = ev.data;
      data.awaitPromise(this._dealer.authenticate(data.token));
    }
    /**
     * Called when the Transport instance is disconnecting.
     */

  }, {
    key: "_onTransportDisconnect",
    value: function _onTransportDisconnect() {
      this._dealer.disconnect();
    }
  }, {
    key: "_onDealerError",
    value: function _onDealerError(ev) {
      var _a;

      (_a = this._mediator) === null || _a === void 0 ? void 0 : _a.emit(PluginEvent.PLUGIN_ERROR, {
        plugin: this.name,
        error: ev.data.error
      });
    }
    /**
     * Attaches the plugin to a Transport instance.
     *
     * @param _t - The Transport instance.
     * @param mediator - The PluginMediator from the Transport instance.
     */

  }, {
    key: "attach",
    value: function attach(_t, mediator) {
      var _mediator$addListener, _this$_dealer$addList;

      this._mediator = mediator;
      mediator.addListeners((_mediator$addListener = {}, _defineProperty(_mediator$addListener, PluginEvent.TRANSPORT_CONNECT, this._onTransportConnect), _defineProperty(_mediator$addListener, PluginEvent.TRANSPORT_AUTHENTICATE, this._onTransportAuthenticate), _defineProperty(_mediator$addListener, PluginEvent.TRANSPORT_DISCONNECT, this._onTransportDisconnect), _mediator$addListener));

      this._dealer.addListeners((_this$_dealer$addList = {}, _defineProperty(_this$_dealer$addList, DealerEvent.DISCONNECTED, this._onDealerDisconnected), _defineProperty(_this$_dealer$addList, DealerEvent.CONNECTION_ID, this._onDealerConnectionId), _defineProperty(_this$_dealer$addList, DealerEvent.MESSAGE, this._onDealerMessage), _defineProperty(_this$_dealer$addList, DealerEvent.REQUEST, this._onDealerRequest), _defineProperty(_this$_dealer$addList, DealerEvent.ERROR, this._onDealerError), _this$_dealer$addList));
    }
    /**
     * Detaches the plugin from a Transport instance.
     *
     * @param _t - The Transport instance.
     * @param mediator - The PluginMediator from the Transport instance.
     */

  }, {
    key: "detach",
    value: function detach(_t, mediator) {
      var _mediator$removeListe, _this$_dealer$removeL;

      this._mediator = undefined;
      mediator.removeListeners((_mediator$removeListe = {}, _defineProperty(_mediator$removeListe, PluginEvent.TRANSPORT_CONNECT, this._onTransportConnect), _defineProperty(_mediator$removeListe, PluginEvent.TRANSPORT_AUTHENTICATE, this._onTransportAuthenticate), _defineProperty(_mediator$removeListe, PluginEvent.TRANSPORT_DISCONNECT, this._onTransportDisconnect), _mediator$removeListe));

      this._dealer.removeListeners((_this$_dealer$removeL = {}, _defineProperty(_this$_dealer$removeL, DealerEvent.DISCONNECTED, this._onDealerDisconnected), _defineProperty(_this$_dealer$removeL, DealerEvent.CONNECTION_ID, this._onDealerConnectionId), _defineProperty(_this$_dealer$removeL, DealerEvent.MESSAGE, this._onDealerMessage), _defineProperty(_this$_dealer$removeL, DealerEvent.REQUEST, this._onDealerRequest), _defineProperty(_this$_dealer$removeL, DealerEvent.ERROR, this._onDealerError), _this$_dealer$removeL));
    }
  }]);

  return DealerPlugin;
}();

export { DealerErrors };
/**
 * Creates a new Dealer Plugin.
 *
 * This function should be passed to `transport.addPlugin()` directly.
 *
 * @param _t - The Transport instance.
 * @param options - The options for the plugin.
 * @returns A new DealerPlugin.
 */

export function dealerCreator(_t, options) {
  return new DealerPlugin(options);
}